import { defineType } from "sanity";
import { multiCurrencyPercentagePreview } from "../../base/multiCurrencyPercentage";

export default defineType({
  name: "multiPercentageTokenValue",
  title: "Multi Percentage Token Value",
  type: "object",
  preview: {
    select: {
      name: "name",
      value: "value"
    },
    prepare({ name, value }) {
      return {
        title: name,
        subtitle: multiCurrencyPercentagePreview(value) || ""
      };
    }
  },
  fields: [
    {
      name: "name",
      title: "Token name",
      type: "string",
      validation: (Rule) => Rule.required()
    },
    {
      name: "value",
      title: "Value",
      type: "multiCurrencyPercentage",
      validation: (Rule) => Rule.required()
    }
  ]
});
